import { useMemo } from 'react';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { mapI18nLocalToDateFns, range } from 'helpers';
import { useTranslation } from 'libs/i18n';

import { Stack } from '../Stack';

import { ContentStyled } from './Calendar.styles';
import { CalendarMonth } from './CalendarMonth';
import { ColoredDates } from './types';

const monthsRange = range(12);

export interface CalendarProps {
  currentDate: Date;
  readOnly?: boolean;
  coloredDates: ColoredDates;
  onClickDay?: (date: Date | null) => void;
  disablePast?: boolean;
}

export const Calendar = ({
  currentDate,
  readOnly,
  coloredDates,
  onClickDay,
  disablePast,
}: CalendarProps) => {
  const { language } = useTranslation();

  const adapterLocale = useMemo(
    () => mapI18nLocalToDateFns(language),
    [language]
  );

  return (
    <LocalizationProvider
      adapterLocale={adapterLocale}
      dateAdapter={AdapterDateFns}
    >
      <Stack spacing={12}>
        <ContentStyled>
          {monthsRange.map((i) => (
            <CalendarMonth
              key={currentDate.toISOString() + i}
              coloredDates={coloredDates || []}
              currentDate={currentDate}
              disablePast={disablePast}
              monthNumber={i}
              readOnly={readOnly}
              onClickDay={onClickDay}
            />
          ))}
        </ContentStyled>
      </Stack>
    </LocalizationProvider>
  );
};
